export default {
  title: 'Push Notifications',

  // Status messages
  status: 'Status',
  permission: 'Permission',
  initializing: 'Initializing...',
  notSupported: 'Push notifications are not supported in this browser',
  subscribing: 'Subscribing...',
  unsubscribing: 'Unsubscribing...',
  sendingTest: 'Sending test notification...',
  sendingBroadcast: 'Sending broadcast notification...',

  // Success messages
  subscribeSuccess: 'Successfully subscribed to push notifications!',
  unsubscribeSuccess: 'Successfully unsubscribed from push notifications',
  testSent: 'Test notification sent!',
  broadcastSent: 'Broadcast sent!',

  // Error messages
  subscriptionFailed: 'Subscription failed',
  unsubscriptionFailed: 'Unsubscription failed',
  testFailed: 'Test notification failed',
  broadcastFailed: 'Broadcast failed',
  adminRequired: 'Admin access required for broadcast notifications',

  // Button labels
  enableNotifications: 'Enable Push Notifications',
  enableNotificationsTitle: 'Enable Push Notifications',
  enableNotificationsDescription: 'Stay informed about important updates and activities in Sloot.',
  subscribeToNotifications: 'Subscribe to Push Notifications',
  unsubscribeFromNotifications: 'Unsubscribe from Push Notifications',
  sendTestNotification: 'Send Test Push Notification',
  sendBroadcastNotification: 'Send Broadcast Notification (Admin)',

  // Modal benefits and content
  benefit1: 'Get notified about new resources and updates',
  benefit2: 'Receive important announcements instantly',
  benefit3: 'Stay connected even when the app is closed',
  permissionNote: 'You can change this setting anytime in your browser preferences.',

  // Instructions
  instructionsTitle: 'Instructions:',
  instruction1: 'Click "Enable Push Notifications" to request permission',
  instruction2: 'Once enabled, you can send test notifications',
  instruction3: 'Push notifications work even when the app is closed',

  // Test notification content
  testNotificationMessage: 'This is a test push notification to verify your subscription is working.',

  // Broadcast notification content
  broadcastTitle: 'Broadcast from Sloot Admin 📢',
  broadcastMessage: 'This is a broadcast message to all subscribers.',

  // Result messages
  resultSent: 'successful',
  resultTotal: 'total',
};
